export default __webpack_public_path__ + "assets/images/2033f807f404ffc371f561ce6a7247a3.png";